import TertiaryButton from '@components/buttons/TertiaryButton';
import BasicCard from '@components/cards/BasicCard';
import styles from '@components/carePlan/CarePlan.module.css';
import BodyCopy from '@components/typography/BodyCopy';

type Props = {
  buttonKey?: string;
  description: string;
};

const CarePlanEmpty = ({ buttonKey, description }: Props) => (
  <div>
    <BasicCard hover="none" padding="small">
      <div className={styles.carePlanEmpty}>
        <BodyCopy color="neutral500">{description}</BodyCopy>
      </div>
    </BasicCard>
    {buttonKey && (
      <div className={styles.disabledButton}>
        <TertiaryButton disabled icon="circleArrowRight" iconPosition="end" textKey={buttonKey} />
      </div>
    )}
  </div>
);

export default CarePlanEmpty;
